import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { initializePromotion, setSnackbarMessage } from '../model/configuratorSlice';
import { EndPoints, PromotionStatus, FeedbackMessages } from '../model/constants';
import { AccessTokenAuth } from '../auth/AccessTokenAuth';
import { DownloadTokenAuth } from '../auth/DownloadToken';
import { RequestBudgetTokenAuth } from '../auth/RequetBudgetToken';

export default function LoadConfigurationService() {
    const {
     currentUnit, settings, user,
    } = useSelector(state => state.configurator);
    const { promotionSlug, code } = useParams();
    const dispatch = useDispatch();

    return useMutation(['loadConfigurationQuery'], (payload) => {
        const unitId = currentUnit !== null ? currentUnit.id : 0;
        // const loadConfigurationUrl = `${EndPoints.LoadConfigUrl}/${promotionSlug}/unit/${unitId}`;
        // const loadConfigurationUrl = `${EndPoints.LoadConfigUrl}/los-cerros`;
        const loadConfigurationUrl = `${EndPoints.LoadConfigUrl}/${promotionSlug}/configuration`;

        const headers = {
            [AccessTokenAuth.HeaderName]: AccessTokenAuth.GetHeaderValue(),
        };

        if (payload.download_token !== null && payload.download_token !== undefined) {
            headers[DownloadTokenAuth.HeaderName] = `token ${payload.download_token}`;
        }

        if (payload.request_budget_token !== null && payload.request_budget_token !== undefined) {
            headers[RequestBudgetTokenAuth.HeaderName] = `token ${payload.request_budget_token}`;
        }

        const config = {
            headers,
        };

        /*
        if (promotionId === 'los-cerros') {
    dispatch(setPromotionId(3135));
    jsonUrl = `${ServerBaseUrl}/demo/${promotionId}/`;
  } else {
    dispatch(setPromotionId(promotionId));
  }

  const { isLoading, error } = useQuery(
      ['configurator'],
      () => fetch(jsonUrl)
          .then(res => res.json()).then(data => dispatch(initializePromotion(data))),
  );
         */

        axios
            .get(loadConfigurationUrl, config)
            .then((response) => {
                dispatch(initializePromotion(response.data));

                const userLoggedIn = user !== null && user.isLoggedIn;
                const endDate = response.data.settings.promotion_end_date;
                const promotionStatus = response.data.settings.promotion_status;

                if (userLoggedIn) {
                    if (promotionStatus === PromotionStatus.RequestBudgetEnded) {
                        dispatch(setSnackbarMessage(FeedbackMessages.RequestBudgetEnded));
                    } else if (endDate !== undefined && endDate.length > 0) {
                        dispatch(setSnackbarMessage(`${FeedbackMessages.RequestBudgetEndDate} ${endDate}`));
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            });
    });
}
